import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'app-digits-input',
  templateUrl: './digits-input.component.html',
  styleUrl: './digits-input.component.scss'
})
export class DigitsInputComponent extends BaseComponent {
  @ViewChild('input1') input1: ElementRef;
  @ViewChild('input2') input2: ElementRef;
  @ViewChild('input3') input3: ElementRef;
  @ViewChild('input4') input4: ElementRef;
  @ViewChild('input5') input5: ElementRef;
  @ViewChild('input6') input6: ElementRef;

  @Output() stringSubmitted = new EventEmitter<string>();

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  onInput(event: Event, currentInput: HTMLInputElement, previousInput: HTMLInputElement | null, nextInput: HTMLInputElement | null): void {
    let value = currentInput.value;

    // Remove any non-numeric characters
    value = value.replace(/\D/g, '');

    // Update the value of the input to ensure it's numeric
    currentInput.value = value;
  
    // Move to next input if a single digit is entered
    if (value.length === 1 && nextInput) {
      nextInput.focus();
      nextInput.select();
    }

    this.verifyAndSubmitDigits();
  }
 

onKeyUp(event: KeyboardEvent, currentInput: HTMLInputElement, previousInput: HTMLInputElement | null, nextInput: HTMLInputElement | null): void {
  // Check if the backspace key was pressed
  if (event.key === 'Backspace' && previousInput && !currentInput.value) {
    previousInput.focus();
    previousInput.select();
  }
}

  // Function to handle paste event
  onPaste(event: ClipboardEvent): void {
    if (!event.clipboardData) {
      return;
    }
  
    let pastedData = event.clipboardData.getData('text');
    pastedData = pastedData.replace(/\D/g, ''); // Ensure only digits are considered
  
    if (pastedData.length === 6) {
      const targetElement = event.target as HTMLInputElement;
      if (targetElement && targetElement.parentElement) {
        const inputs = targetElement.parentElement.querySelectorAll('input');
        inputs.forEach((input: HTMLInputElement, index: number) => {
          if (input) {
            input.value = pastedData[index] || '';
          }
        });
  
        // Focus the last input if you want
        const lastInput = inputs[inputs.length - 1] as HTMLInputElement;
        if (lastInput) {
          lastInput.focus();
        }
      }

      this.verifyAndSubmitDigits();
    }
  }

  concatenateDigits() : string {
    const codeArray = [
      this.input1.nativeElement.value,
      this.input2.nativeElement.value,
      this.input3.nativeElement.value,
      this.input4.nativeElement.value,
      this.input5.nativeElement.value,
      this.input6.nativeElement.value
    ];

    const concatenatedCode = codeArray.join('');

    return concatenatedCode;
  }

  verifyAndSubmitDigits(): void {
    const userCode= this.concatenateDigits();      // if not all digits were entered - do nothing
      
    if (userCode.length < 6){
        return;
    }
  
    this.stringSubmitted.emit(userCode);
  }
}
